<template>
  <main class="ws-page">
    <header class="ws-page-header">
      <h1 class="ws-page-header__title has-text-weight-bold is-size-2" v-text="$t('Эксперты')"></h1>
    </header>
    <ws-experts-list />
  </main>
</template>

<script>
import WsExpertsList from '@/components/de/experts/WsExpertsList'
export default {
  name: 'Experts',
  components: { WsExpertsList },
  methods: {
  }
}
</script>
